// src/pages/Attendance.js
import React, { useState } from 'react';
import { Button, Grid } from '@mui/material';
import AttendanceTable from './AttendanceTable ';
import AddAttendanceForm from './AddAttendanceForm';
import ExportButtons from './ExportButtons';
// src/data/staticAttendanceData.js

const staticAttendanceData = [
    {
      date: "2024-10-01",
      records: [
        { id: 1, name: "John Doe", status: "Present" },
        { id: 2, name: "Jane Smith", status: "Absent" },
        { id: 3, name: "Alice Johnson", status: "Present" },
        { id: 4, name: "Bob Brown", status: "Present" },
        { id: 5, name: "Charlie Davis", status: "Absent" },
      ],
    },
    {
      date: "2024-10-02",
      records: [
        { id: 1, name: "John Doe", status: "Absent" },
        { id: 2, name: "Jane Smith", status: "Present" },
        { id: 3, name: "Alice Johnson", status: "Present" },
        { id: 4, name: "Bob Brown", status: "Absent" },
        { id: 5, name: "Charlie Davis", status: "Present" },
      ],
    },
    {
      date: "2024-10-03",
      records: [
        { id: 1, name: "John Doe", status: "Present" },
        { id: 2, name: "Jane Smith", status: "Present" },
        { id: 3, name: "Alice Johnson", status: "Absent" },
        { id: 4, name: "Bob Brown", status: "Present" },
        { id: 5, name: "Charlie Davis", status: "Absent" },
      ],
    },
    // Add more records as needed
  ];
  
  
const Attendance = ({records}) => {

  const [open, setOpen] = useState(false);

  const handleOpenForm = () => {
    setOpen(true);
  };

  const handleCloseForm = () => {
    setOpen(false);
  };

  return (
    <Grid container spacing={3} sx={{ padding: 3 }}>
      <Grid item xs={12}>
        <Button variant="contained" color="primary" onClick={handleOpenForm}>
          Mark Attendance
        </Button>
      </Grid>
      <Grid item xs={12}>
        <AttendanceTable tableData={records}/>
      </Grid>
      <AddAttendanceForm open={open} handleClose={handleCloseForm} />
      <ExportButtons data={staticAttendanceData}/>
    </Grid>
  );
};

export default Attendance;
